<!-- Step 1 -->

    <form [formGroup]="form1">

      <div class="container-form margin-auto">

        <span class="title-filter bold primary">{{ "basic-register" | translate }}</span>

        <!-- Email -->
        <mat-form-field appearance="legacy" class="margin-top-1">
          <mat-label>{{ "email" | translate }}</mat-label>
          <input
            matInput
            formControlName="email"
            name="email"
            class="form-control"
            autocomplete="off"
          />
          <mat-error *ngIf="emailNoValido">
            {{ "valid-email" | translate }}
          </mat-error>
        </mat-form-field>

        <!-- Name -->
        <mat-form-field appearance="legacy" class="margin-top-1">
          <mat-label>{{ "name" | translate }}</mat-label>
          <input
            matInput
            class="form-control"
            formControlName="name"
            name="given-name"
            autocomplete="off"
          />
          <mat-error *ngIf="invalidName">
            {{ "valid-name" | translate }}
          </mat-error>
        </mat-form-field>

        <!-- Surname -->
        <mat-form-field appearance="legacy" class="margin-top-1">
          <mat-label>{{ "surname" | translate }}</mat-label>
          <input
            matInput
            class="form-control"
            formControlName="surname"
            name="family-name"
            autocomplete="off"
          />
          <mat-error *ngIf="invalidSurName">
            {{ "valid-surname" | translate }}
          </mat-error>
        </mat-form-field>

        <!-- Password -->
        <mat-form-field appearance="legacy" class="margin-top-1">
          <mat-label>{{ "password" | translate }}</mat-label>
          <input
            matInput
            class="form-control"
            formControlName="password"
            type="password"
            name="new-password"
            autocomplete="off"
          />
          <mat-error *ngIf="invalidPassword">
            {{ "valid-password" | translate }}
          </mat-error>
        </mat-form-field>

        <!-- Repeat Password -->
        <mat-form-field appearance="legacy" class="margin-top-1">
          <mat-label>{{ "repeat-password" | translate }}</mat-label>
          <input
            matInput
            class="form-control"
            formControlName="repeatPassword"
            type="password"
            name="repeatPassword"
            autocomplete="off"
          />
          <mat-error *ngIf="invalidRepeatPassword">
            {{ "valid-repeat-password" | translate }}
          </mat-error>
        </mat-form-field>

        <mat-checkbox
          class="margin-top-1"
          formControlName="policy"
          color="primary"
        >
          <span
            [class.red]="invalidPolicy"
            [innerHTML]="'accept-policy' | translate"
          >
          </span>
        </mat-checkbox>

        <!-- Button -->
        <div class="button-group margin-top-1 margin-bottom-05">

            <button
            mat-raised-button
            color="primary"
            type="button"
            (click)="registerTeacher()"
            [class.spinner]="loading"
            [disabled]="loading"
          >
            <span>{{ "send" | translate }}</span>
          </button>

        </div>




      </div>
    </form>